var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "work-toolbar" },
    [
      _vm.searchExpanded
        ? _c(
            "div",
            { staticClass: "work-toolbar__search" },
            [
              _c("icon-search", { staticClass: "work-toolbar__search-icon" }),
              _c("input", {
                ref: "searchInput",
                staticClass: "work-toolbar__search-input",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("assistantCatHome.workSelect.searchHint"),
                },
                domProps: { value: _vm.searchQuery },
                on: { input: _vm.onSearchInput },
              }),
              _c("button", {
                staticClass: "work-toolbar__close",
                attrs: { type: "button", "aria-label": _vm.$t("common.close") },
                on: { click: _vm.onCloseSearch },
              }),
            ],
            1
          )
        : [
            _c(
              "button",
              {
                staticClass: "work-toolbar__icon",
                class: { "work-toolbar__icon--active": !!_vm.searchQuery },
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t(
                    "assistantCatHome.workSelect.searchHint"
                  ),
                },
                on: { click: _vm.onOpenSearch },
              },
              [_c("icon-search", { staticClass: "work-toolbar__svg" })],
              1
            ),
            _c(
              "button",
              {
                staticClass: "work-toolbar__icon",
                class: { "work-toolbar__icon--active": _vm.hasActiveFilter },
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("homePage.novelList.filter.dialogTitle"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("open-filter")
                  },
                },
              },
              [_c("icon-slider", { staticClass: "work-toolbar__svg" })],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }